module.exports = __webpack_public_path__ + "static/img/01_pro.e147d7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/01_pro.jpg
// module id = gx0M
// module chunks = 0